/* eslint-disable quotes */
import { snakelize, camelize } from '../../../helpers/object'

export default ($axios: any) => ({
  // 로그인
  async login(data?: any) {
    return await $axios.post(`/auth`, snakelize(data))
  },

  // 회원 정보
  async show(data?: any) {
    return camelize(await $axios.get(`/auth/${data.brandToken}`))
  },
})
